import PropTypes from 'prop-types';
import React from 'react';
import { CheckBoxField, RadioField } from '@unite-us/app-components';
import { CONSENT_OPTIONS } from 'src/components/InformedConsent/constants';
import { env } from 'src/config/env';
import ConsentFileUpload from './ConsentFileUpload';
import DownloadConsentFormLink from './DownloadConsentFormLink';

const BOOL_OPTIONS = [
  { label: 'Yes', value: 'accepted' },
  { label: 'No', value: 'declined' },
];

const NHDocumentUploadSection = ({ fields, sentReferrals }) => (
  <>
    <div className="flex justify-between">
      <span className={fields[CONSENT_OPTIONS.NH_DOCUMENT]?.invalid ? 'text-red' : ''}>
        New Hampshire Consent <span className="text-red">*Required</span>
      </span>
      <DownloadConsentFormLink
        text="Download New Hampshire consent form"
        url={env.NH_CONSENT_DOWNLOAD_URL}
      />
    </div>
    <ConsentFileUpload name="NHConsent" type={CONSENT_OPTIONS.DOCUMENT} />
    <div className="flex flex-col space-y-6">
      <p>Discretely document the client&apos;s responses to the New Hampshire consent form below.</p>
      <div className="flex flex-col space-y-4">
        <p>
          Did the client agree to share referral-specific information with a
          Network of health and social service partners powered by Unite Us software?
          Select which of the following referrals your client consented to sharing information about.
        </p>
        <div className="flex flex-col space-y-4">
          {sentReferrals.map(({ serviceName, programNames }, index) => (
            <CheckBoxField
              field={fields[CONSENT_OPTIONS.NH_DOCUMENT_REFERRALS][index]}
              label={`Referral for ${serviceName}: ${
                programNames.join(', ')
              }`}
              showError={false}
              showHint={false}
            />
          ))}
        </div>
      </div>
      <div className="flex flex-col space-y-4">
        <RadioField
          id="referral_specific_radio"
          labelClassName="text-sm font-regular-font mb-4"
          label={(
            <>
              Did the client consent to sharing referral-specific information?{' '}
              <span className="text-red">*Required</span>
            </>
          )}
          field={{
            ...fields[CONSENT_OPTIONS.NH_DOCUMENT_REFERRAL_SPECIFIC],
            invalid: !fields[CONSENT_OPTIONS.NH_DOCUMENT_REFERRAL_SPECIFIC].value,
          }}
          options={BOOL_OPTIONS}
        />
      </div>
      <div className="flex flex-col space-y-4">
        <RadioField
          id="state_share_radio"
          labelClassName="text-sm font-regular-font mb-4"
          label={(
            <>
              Did the client consent to sharing their information with the state of New Hampshire?{' '}
              <span className="text-red">*Required</span>
            </>
          )}
          field={{
            ...fields[CONSENT_OPTIONS.NH_DOCUMENT_STATE_SHARE],
            invalid: !fields[CONSENT_OPTIONS.NH_DOCUMENT_STATE_SHARE].value,
          }}
          options={BOOL_OPTIONS}
        />
      </div>
    </div>
    <div className="border-b border-solid border-light-border-blue" />
  </>
);

NHDocumentUploadSection.propTypes = {
  fields: PropTypes.object.isRequired,
  sentReferrals: PropTypes.array.isRequired,
};

export default NHDocumentUploadSection;
